import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoMosaicWidget" */ './CasinoMosaicWidget'),
  modules: ['./CasinoMosaicWidget'],
  loading: () => <div />
});

export default LoadableWidget;
